// extracted by mini-css-extract-plugin
export default {"wrapperInfoAboutPublic":"InfoAboutPublic_wrapperInfoAboutPublic__+VBnU","PrivateLink":"InfoAboutPublic_PrivateLink__xwPOs","OpenLink":"InfoAboutPublic_OpenLink__YnTtU"};